import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";

import Dropdown from "components/Dropdown";

import WithFormField from "../WithFormField";

export function ControlledDropdown({
  name,
  initialValue,
  required,
  errorMessage,
  ...props
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name: name,
    defaultValue: initialValue,
    rules: { required: { value: required, message: errorMessage } },
  });

  return (
    <Dropdown
      value={field.value}
      error={Boolean(error)}
      onBlur={field.onBlur}
      onChange={(_, newValue) => {
        field.onChange(newValue);
      }}
      {...props}
    />
  );
}

ControlledDropdown.propTypes = {
  name: PropTypes.string,
  initialValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
};

ControlledDropdown.defaultProps = {
  initialValue: null,
  name: "dropdown",
  required: false,
  errorMessage: "",
};

export default WithFormField(ControlledDropdown);
